
// 多站点配置 — 通过 NUXT_PUBLIC_SITE 环境变量切换
// 用法: npm run dev:iqiqgame / npm run dev:lekas / npm run dev:leafly

export interface CmsSiteConfig {
    baseApiUrl: string
    websiteName: string
    gaId: string
    cdnUrl: string
}

const SITE_CONFIGS: Record<string, CmsSiteConfig> = {
    'iqiqgame-com': {
        baseApiUrl: 'http://localhost:8080',
        websiteName: 'iqiqgame-com',
        gaId: 'G-WW044BCBRS',
        cdnUrl: 'https://images.iqiqgame.com'
    },
    'lekas-us': {
        baseApiUrl: 'http://localhost:8080',
        websiteName: 'lekas-us',
        gaId: 'G-TPRBR9Z201',
        cdnUrl: 'https://images.lekas.us'
    },
    'leaflypackaging-com': {
        baseApiUrl: 'http://localhost:8080',
        websiteName: 'leaflypackaging-com',
        gaId: 'G-T27Q6Y05GY',
        cdnUrl: 'https://images.leaflypackaging.com'
    }
}

const siteName = process.env.NUXT_PUBLIC_SITE

const siteKeys = Object.keys(SITE_CONFIGS)
const defaultSiteKey = siteKeys[0]!

let config: CmsSiteConfig

if (siteName && siteKeys.includes(siteName)) {
    config = SITE_CONFIGS[siteName as keyof typeof SITE_CONFIGS]!
    console.log(`[cmsConfig] Active site: ${config.websiteName}`)
} else {
    if (siteName) {
        console.error(`[ERROR] 未知站点: "${siteName}"，可用: ${siteKeys.join(', ')}`)
    }
    config = SITE_CONFIGS[defaultSiteKey]!
}

export default config 
